import { articles } from '@/mocks/communityData';
import SectionHeading from './SectionHeading';

const tagClass: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function Highlights() {
  return (
    <section id="highlights" className="bg-background-100 border-t border-background-200/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="心得精选"
            title="真实看料心得，越分享越有料"
            desc="每一篇都来自料友的真实感受与经验，涵盖新手避坑与老手进阶，随便点开一篇都有收获。"
          />
          <a
            href="#join"
            className="whitespace-nowrap self-start rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            去分享你的心得
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((a) => (
            <a
              key={a.title}
              href="#highlights"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-50 transition-colors hover:border-accent-300 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={a.image}
                  alt={a.alt}
                  className="h-40 w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${tagClass[a.tagColor]}`}
                >
                  {a.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {a.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-2">{a.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="font-medium text-foreground-800">{a.author}</span>
                    <span>·</span>
                    <span className="whitespace-nowrap">{a.time}</span>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {a.comments}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-heart-3-line"></i>
                      {a.likes}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}